<div class="modal-dialog" [attr.role]="'document'">
    <div class="modal-content">
        <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
            <button class="btn btn-default-reverse btn-block btn-sm" [attr.data-dismiss]="'modal'" type="button"
                (click)="createForm();">Chiudi</button>
        </p>
        <div>
            <div class="col-sm-12 coldx">
                <h4>{{ (inserimento) ? 'Aggiungi ' : 'Modifica' }} scheda recupero</h4>
                <ng-template [ngIf]="inserimento">
                    <div class="col-sm-12 coldx" 
                        [ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
                        <h4 *ngIf="title">{{title}}</h4>
                        <form class="cerca_grey">
                            <div class="row">
                                <p class="col-sm-12">
                                    <label for="ceerca_lbl">Cerca</label> <input id="ceerca_lbl" type="text" #searchItem (keyup)="0" class="form-control"
                                        placeholder="Inserisci numero" />
                                </p>
                            </div>
                        </form>
                        <ng-template [ngIf]="esitiAll && esitiAll.length > 0">
                            <ul id="controparticollapse" class="controparti">

                                <ng-template ngFor let-esito
                                    [ngForOf]="esitiAll | searchFilter : searchItem.value : 'numeroEsito'  ">
                                    <li class="panel">
                                        <div class="controparte">
                                            <p class="col-xs-12 col-sm-2">
                                                <button class="btn btn-primary associa" (click)="associaEsito(esito);"
                                                    type="submit">Associa</button>
                                            </p>
                                            <h4 class="titolo col-sm-2">
                                                {{esito.tipoEsito?.label}}
                                            </h4>

                                            <p class="col-sm-3">
                                                N&deg;: <strong>{{esito.numeroEsito}}</strong>
                                            </p>
                                            <p class="col-sm-3">
                                                Deposito:
                                                <strong>{{esito.dataDeposito ? (esito.dataDeposito | date:'dd/MM/yyyy'): ''}}</strong>
                                            </p>
                                            <p class="col-sm-2">
                                                Definitivo: <strong>{{esito.definitivo ? "Si" :	"No"}}</strong>
                                            </p>
                                        </div>
                                    </li>
                                </ng-template>
                            </ul>
                        </ng-template>
                        <ng-template [ngIf]="esitiAll.length === 0 && msgNoBeneficiari">
                            <p>{{msgNoBeneficiari}}</p>
                        </ng-template>
                    </div>
                </ng-template>
                <ng-template [ngIf]="schedaRecuperoForm">
                    <div class="col-sm-12 coldx" 
                        [ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
                        <h4 *ngIf="title">{{title}}</h4>
                        <div class="tab-content">
                            <form #f="ngForm" [formGroup]="schedaRecuperoForm" (ngSubmit)="update();">
                                <!-- <div class="row">

                                    <div textInput [control]="schedaRecuperoForm.controls['societa']"
                                        class="col-sm-4" [labelInput]="'Societ&agrave;'" [submitPending]="true"
                                        formControlName="societa" [ngModel]="classificazione.materia?.label">
                                    </div>

                                    <div textInput [control]="schedaRecuperoForm.controls['materia']"
                                        class="col-sm-4" [labelInput]="'Materia'" [submitPending]="true"
                                        formControlName="materia" [ngModel]="classificazione.oggetto?.label">
                                    </div>

                                    <div textInput [control]="schedaRecuperoForm.controls['argomento']"
                                        class="col-sm-4" [labelInput]="'Argomento'" [submitPending]="true"
                                        formControlName="argomento" [ngModel]="classificazione.argomento?.label">
                                    </div>
                                </div> -->
                                <div class="row">

                                    <div textInput class="col-sm-3" [labelInput]="'Posizione'" [submitPending]="true"
                                        formControlName="posizione" [ngModel]="fascicolo?.posizione"></div>

                                    <div naturalNumberInput
                                        [control]="schedaRecuperoForm.controls['numeroProvvedimento']" class="col-sm-3"
                                        [labelInput]="'N. provvedimento'" [maxLength]="'255'" [submitPending]="true"
                                        formControlName="numeroProvvedimento" [ngModel]="request.esito?.numeroEsito">
                                    </div>

                                    <div textInput class="col-sm-3" [labelInput]="'Provvedimento'"
                                        [submitPending]="true" formControlName="provvedimento"
                                        [ngModel]="request.esito?.tipoEsito.descrizione"></div>

                                    <div datePickerInput [control]="schedaRecuperoForm.controls['dataProvvedimento']"
                                        [submitPending]="true" class="col-sm-3" [labelInput]="'Data provvedimento'"
                                        formControlName="dataProvvedimento" [ngModel]="request.esito?.dataDeposito">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <strong>Classificazioni</strong>
                                        <table class="table-striped table aggiunta_classificazione"
                                            style="margin-top: 8px;">
                                            <caption class="sr-only">Tabella classificazioni</caption>
                                            <tbody>
                                                <tr>
                                                    <th>Societ&agrave; - CCNL</th>
                                                    <th>Materia</th>
                                                    <th>Argomento</th>
                                                </tr>
                                                <ng-template ngFor let-classificazione
                                                    [ngForOf]="getClassificazioniEsito()">
                                                    <tr>
                                                        <td>
                                                            <p *ngIf="classificazione.materia?.descrizione">
                                                                {{classificazione.materia?.descrizione}}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p *ngIf="classificazione.oggetto?.descrizione">
                                                                {{classificazione.oggetto?.descrizione }}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p *ngIf="classificazione.argomento?.descrizione">
                                                                {{classificazione.argomento?.descrizione}}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>

                                    </div>

                                </div>

                                <div class="row" *ngIf="!getClassificazioniEsito() || getClassificazioniEsito().length === 0">
                                    <div class="col-sm-12">
                                        <p>{{msgNoClassificazioni}}</p>
                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-sm-12">
                                        <strong>Parti</strong>
                                        <table class="table-striped table aggiunta_classificazione"
                                            style="margin-top: 8px;">
                                            <caption class="sr-only">Tabella parti</caption>
                                            <tbody>
                                                <tr>
                                                    <th>Nominativo</th>
                                                    <th>Codice fiscale</th>
                                                </tr>
                                                <ng-template ngFor let-controparte [ngForOf]="getContropartiEsito()">
                                                    <tr>
                                                        <td>
                                                            <p *ngIf="controparte.parte?.nominativo">
                                                                {{controparte.parte?.nominativo | capitalize}}
                                                            </p>
                                                            <p
                                                                *ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                                                                {{controparte.parte?.cognome | capitalize}}
                                                                {{' ' + controparte.parte?.nome | capitalize}}
                                                            </p>
                                                            <p
                                                                *ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                                                                {{controparte.parte?.ragioneSociale}}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p *ngIf="controparte.parte.codiceFiscale">
                                                                {{controparte.parte.codiceFiscale | uppercase}}
                                                            </p>
                                                            <!-- <p *ngIf="controparte.parte.matricola && !controparte.parte.codiceFiscale">
                                                            {{controparte.parte.matricola}}
                                                        </p> -->
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>

                                    </div>

                                </div>

                                <div class="row" *ngIf="!getContropartiEsito() || getContropartiEsito().length === 0">
                                    <div class="col-sm-12">
                                        <p>{{msgNoControparti}}</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div textAreaInput class="col-sm-12" [labelInput]="'Descrizione'" formControlName="descrizione"
                                        [(ngModel)]="request.descrizione"></div>
                                </div>

                                <div class="row">
                                    <div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note"
                                        [(ngModel)]="request.note"></div>
                                </div>
                                <!-- <div class="row">
              <p class="mandatory col-sm-12">
                <em>* Campi obbligatori</em>
              </p>
            </div> -->
                                <div class="row">
                                    <p class="col-sm-3 col-xs-6">
                                        <button type="button" class="btn btn-outline-secondary btn-block"
                                            (click)="resetForm();">Reset</button>
                                    </p>
                                    <p submitButton [disabled]="!schedaRecuperoForm.valid"
                                        class="col-sm-3 col-xs-6 col-sm-offset-6"
                                        [labelButton]="'Salva'"></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>